module.exports = __webpack_public_path__ + "img/sensor.58b79dc6.svg";